export enum ProjectTypeName {
  dapp = 'DApp',
  network = 'Network',
  company = 'Company',
}
